module.exports = __webpack_public_path__ + "img/ic_findjobs_disabled.041276c0.svg";